import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { LoginService } from '../../service/login.service';

@Component({
  selector: 'app-thank-you-messages',
  templateUrl: './thank-you-messages.component.html',
  styleUrls: ['./thank-you-messages.component.css']
})
export class ThankYouMessagesComponent implements OnInit {

  public status: string;
  public registration: boolean;
  public confirm: boolean;
  public linkexpired: boolean;
  public forgotPassword: boolean;
  public resetPassword: boolean;
  public verificationlinkResent: boolean;
  public contactdetails: boolean;
  public confirmationError: boolean;

  constructor(
    private loginService: LoginService,
    private route: ActivatedRoute,
    private router: Router
  ) { }

  ngOnInit() {
    this.status = "";
    this.registration = false;
    this.confirm = false;
    this.linkexpired = false;
    this.forgotPassword = false;
    this.resetPassword = false;
    this.verificationlinkResent = false;
    this.contactdetails = false;
    this.confirmationError = false;

    this.status = this.route.snapshot.queryParams.status;
    if (this.status == "registration") {
      this.registration = true;
    }
    else if (this.status == "confirm") {
      this.confirm = true;
    }
    else if (this.status == "linkexpired") {
      this.linkexpired = true;
    }
    else if (this.status == "forgotPassword") {
      this.forgotPassword = true;
    }
    else if (this.status == "resetPassword") {
      this.resetPassword = true;
    }
    else if (this.status == "verificationlinkResent") {
      this.verificationlinkResent = true;
    }
    else if (this.status == "contactdetails") {
      this.contactdetails = true;
    }
    else {
      this.confirmationError = true;
    }
  }
}
